"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // @ts-check

var _noExchanges = require("./no-exchanges");

var _noExchanges2 = _interopRequireDefault(_noExchanges);

var _partnerCallExchange = require("./partner-call-exchange");

var _partnerCallExchange2 = _interopRequireDefault(_partnerCallExchange);

var _partnerExchange = require("./partner-exchange");

var _partnerExchange2 = _interopRequireDefault(_partnerExchange);

var _stationExchange = require("./station-exchange");

var _stationExchange2 = _interopRequireDefault(_stationExchange);

var _timePeriod = require("../../v2/time-period");

var _timePeriod2 = _interopRequireDefault(_timePeriod);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param {V2.ExchangeDataGrouping} policy_grouping
 * @param {string} locale
 * @returns {V2.ExchangePolicy}
 */
function exchangePolicy(policy_grouping, locale) {
  var types = {
    "no-exchange": _noExchanges2.default,
    station: _stationExchange2.default,
    unspecified: _noExchanges2.default,
    external: _partnerExchange2.default,
    "call-operator": _partnerCallExchange2.default
  };
  var policy_group_info = types[policy_grouping.type](policy_grouping);
  var timeline = policy_grouping.policies.map(function (time_period) {
    return (0, _timePeriod2.default)(time_period, locale);
  });

  return _extends({}, policy_group_info, { timeline: timeline });
}

exports.default = exchangePolicy;
module.exports = exports.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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